import i18n from 'src/i18n/index.js';

export default ({ app }) => {
  // Tell app to use the I18n instance
  app.use(i18n);
};
